/*
  Deposit List / reconciled-grid ordering. Mirrors
  tmc-local-backend src/graphql/taxProgram/taxCheckReconciliation/taxCR.helper.js - the screen
  and the printed list have to agree, so keep the two comparators in step.

  `order` is workstation * 1000 + per-workstation sequence, so sorting on it can only ever
  group by workstation. Counties that reconcile one workstation at a time want exactly that.
  Counties that combine every check into one stack in bank order and scan it on a single
  scanner need the order the checks actually went through the scanner (TKT-001049), which is
  what reconciledAt records.
*/
export const DEPOSIT_LIST_ORDER_RECONCILED = 'reconciled';
export const DEPOSIT_LIST_ORDER_WORKSTATION = 'workstation';

export const isReconciledOrderMode = (paymentSettingItem) => (
  (paymentSettingItem || {}).depositListOrder === DEPOSIT_LIST_ORDER_RECONCILED
);

const reconciledAtMs = (item) => {
  const at = item && item.reconciledAt;
  if (at === undefined || at === null || at === '') return null;
  const ms = at instanceof Date ? at.getTime() : new Date(at).getTime();
  return Number.isNaN(ms) ? null : ms;
};

export const compareByOrderThenPaymentNumber = (a, b) => {
  // a check with no position at all sorts to the end
  if (a.order === undefined || a.order === null) return 1;
  if (b.order === undefined || b.order === null) return -1;
  if (a.order !== b.order) {
    return a.order - b.order;
  }
  // secondary sort by receipt/payment number so same-workstation ties stay in the order paid
  const aNum = a.paymentNumber === undefined || a.paymentNumber === null ? '' : a.paymentNumber;
  const bNum = b.paymentNumber === undefined || b.paymentNumber === null ? '' : b.paymentNumber;
  if (aNum === bNum) return 0;
  return aNum > bNum ? 1 : -1;
};

export const compareByReconciledAtThenOrder = (a, b) => {
  const aPlaced = !(a.order === undefined || a.order === null);
  const bPlaced = !(b.order === undefined || b.order === null);
  if (!aPlaced && !bPlaced) return 0;
  if (!aPlaced) return 1;
  if (!bPlaced) return -1;

  const aAt = reconciledAtMs(a);
  const bAt = reconciledAtMs(b);
  /*
    Checks reconciled before this release carry no stamp. They can only be ordered by
    `order`, and they were reconciled earlier than anything stamped, so they lead.
  */
  if (aAt === null && bAt === null) return compareByOrderThenPaymentNumber(a, b);
  if (aAt === null) return -1;
  if (bAt === null) return 1;
  if (aAt !== bAt) return aAt - bAt;
  return compareByOrderThenPaymentNumber(a, b);
};

export const depositListComparator = (paymentSettingItem) => (
  isReconciledOrderMode(paymentSettingItem)
    ? compareByReconciledAtThenOrder
    : compareByOrderThenPaymentNumber
);

export default {};
